import React, { useState } from "react";
import axios from "../utils/axiosConfig";

const ReminderModal = ({ dealId, onClose }) => {
  const today = new Date();
  const [date, setDate] = useState(`${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`);
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const save = async event => {
    event.preventDefault();
    if (saving) return;
    if (!message.trim()) { setError("Enter a reminder message"); return; }
    setSaving(true);
    setError("");
    try {
      await axios.post(`/newdeal/${dealId}/reminders`, { date, message: message.trim() });
      onClose();
    } catch (err) { setError(err.response?.data?.message || "Unable to save reminder"); }
    finally { setSaving(false); }
  };
  return <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog"><form className="modal-content" role="dialog" aria-modal="true" aria-labelledby="reminder-title" onSubmit={save}>
      <div className="modal-header"><h5 id="reminder-title">Reminder — Deal {dealId}</h5>
        <button type="button" className="btn-close" aria-label="Close reminder" disabled={saving} onClick={onClose} /></div>
      <div className="modal-body">
        <p>Due reminders will appear on the dashboard for all users.</p>
        <label htmlFor="reminder-date" className="form-label">Reminder Date</label>
        <input id="reminder-date" type="date" required className="form-control mb-3" value={date} onChange={e => setDate(e.target.value)} />
        <label htmlFor="reminder-message" className="form-label">Message</label>
        <textarea id="reminder-message" required autoFocus className="form-control" rows="3" value={message} onChange={e => setMessage(e.target.value)} />
        {error && <div role="alert" className="text-danger mt-2">{error}</div>}
      </div>
      <div className="modal-footer"><button type="submit" className="btn btn-success" disabled={saving}>{saving ? "Saving…" : "Save Reminder"}</button>
        <button type="button" className="btn btn-secondary" disabled={saving} onClick={onClose}>Close</button></div>
    </form></div>
  </div>;
};
export default ReminderModal;
